import React, { useState } from "react";
// import { Link } from "react-router-dom";
// axios is mainly used to handle api requests in react
// import axios from "axios";

import "./Contact.css";
import { BsGithub, BsInstagram, BsLinkedin } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import Slide from "react-reveal/Slide";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// handling contact form
const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  // const baseUrl = "http://my-mern-portfolio-r0c1.onrender.com:10000";

  //handle submit button

  const sendEmail = async (e) => {
    e.preventDefault();
    try {
      if (!name || !email || !msg) {
        toast.error("Please Provide all fields");
        return;
      }
      let dataSend = {
        name: name,
        email: email,
        msg: msg,
      };

      const res = await fetch(`/email/sendEmail`, {
        method: "POST",
        body: JSON.stringify(dataSend),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (res && res.status === 200) {
        // toast.success(res.data.message);
        toast.success("Message sent Successfully");
        setName("");
        setEmail("");
        setMsg("");
        toast.info("I will respond back soon !");
        // console.log("this is running ");
      } else {
        toast.error(res.data.message);
      }

      //validation success
    } catch (error) {
      console.log(error);
      toast.error("An error occurred");
    }
  };

  return (
    <>
      <div className=" contact">
        <Slide right>
          <div className="card card0 border-0">
            <div className="row">
              <div className="col-md-6 col-lg-6 col-xl-6 ">
                <div className="card1">
                  <div className="row image border-line">
                    <img
                      src="https://www.momonwatch.com/wp-content/uploads/2020/06/5-1020x600.png"
                      alt="oncontact"
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="card2 d-flex card border-0 mt-5 px-4 py-2">
                  <div className="row">
                    <div className="row">
                      <h5>
                        Contact Me
                        <a
                          href="https://linkedin.com"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <BsLinkedin color="blue" size={30} className="ms-2" />
                        </a>
                        <a
                          href="https://github.com/Heroshi1947"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <BsGithub color="black" size={30} className="ms-2" />
                        </a>
                        <a
                          href="https://www.instagram.com/5h1v_0m_/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <BsInstagram
                            color="purple"
                            size={30}
                            className="ms-2"
                          />
                        </a>
                        <a
                          href="https://mail.google.com/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <MdEmail color="red" size={30} className="ms-2" />
                        </a>
                      </h5>
                    </div>

                    <div className="row px-3 mb-4">
                      <div className="line " />
                      <small className="or text-center"> OR </small>
                      <div className="line" />
                    </div>
                    <div className="row px-3">
                      <input
                        type="text"
                        name="name"
                        placeholder="Enter your Name"
                        className="mb-3"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className="row px-3">
                      <input
                        type="text"
                        name="Email"
                        placeholder="Enter Email id"
                        className="mb-3"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="row px-3">
                      <textarea
                        type="text"
                        name="Message"
                        placeholder="Write your message"
                        className="mb-3"
                        value={msg}
                        onChange={(e) => setMsg(e.target.value)}
                      />
                    </div>
                    <div className="row px-3">
                      <button
                        className="btn button"
                        type="submit' "
                        onClick={sendEmail}
                      >
                        SEND
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slide>
      </div>
    </>
  );
};

export default Contact;
